export default {
  env: "shop",
  configs: {
    shop: {
      serverUrl: "https://zwizai.herokuapp.com/",
      liffId: "1654004191-nP40E5DZ",
    },
    shopcommu: {
      serverUrl: "https://communitybotbyzwizai.herokuapp.com/",
      liffId: "1654004191-KMDEAnNY",
    },
  },
  color: {
    primary: "#cecece",
  },
  getConfig: function (type) {
    if (this.configs[this.env].hasOwnProperty(type)) {
      return this.configs[this.env][type];
    } else {
      throw "Not found this variable";
    }
  },
};
